// Transforma o user agent de uma sessão em um rótulo legível, ex.: "Chrome no Windows".
//
// A ordem das regras importa: Edge e Opera também anunciam "Chrome", o Chrome também
// anuncia "Safari", e iPhone/iPad anunciam "Mac OS X"; por isso os mais específicos vêm antes.

const OS_RULES = [
  { pattern: /iPad/i, name: 'iPad' },
  { pattern: /iPhone|iPod/i, name: 'iPhone' },
  { pattern: /Android/i, name: 'Android' },
  { pattern: /Windows/i, name: 'Windows' },
  { pattern: /Macintosh|Mac OS X/i, name: 'macOS' },
  { pattern: /Linux|X11|CrOS/i, name: 'Linux' },
];

const BROWSER_RULES = [
  { pattern: /Edg(e|A|iOS)?\//i, name: 'Edge' },
  { pattern: /OPR\/|Opera/i, name: 'Opera' },
  { pattern: /Firefox\/|FxiOS\//i, name: 'Firefox' },
  { pattern: /Chrome\/|CriOS\//i, name: 'Chrome' },
  { pattern: /Safari\//i, name: 'Safari' },
];

const MOBILE_OS = ['iPhone', 'iPad', 'Android'];

const findMatch = (rules, userAgent) => {
  const rule = rules.find(({ pattern }) => pattern.test(userAgent));
  return rule ? rule.name : null;
};

export const parseUserAgent = (userAgent) => {
  const ua = userAgent || '';
  return {
    browser: findMatch(BROWSER_RULES, ua),
    os: findMatch(OS_RULES, ua),
  };
};

export const isMobileUserAgent = (userAgent) => MOBILE_OS.includes(parseUserAgent(userAgent).os);

const userAgentLabel = (userAgent) => {
  const { browser, os } = parseUserAgent(userAgent);

  if (browser && os) return `${browser} no ${os}`;
  if (browser) return browser;
  if (os) return `Navegador no ${os}`;
  return 'Navegador desconhecido';
};

export default userAgentLabel;
